<template>
  <div>
    <div class="animated fadeIn">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="true"
      />
    </div>
    <b-col cols="12">
      <transition name="slide">
        <b-card
          tag="article"
          style="max-width: 100%"
          class="mb-2"
          header-tag="header"
        >
          <template #header>
            <h5>Lista de Produtos</h5>
          </template>
          <b-row>
            <b-col xl="4" lg="6" md="12" sm="12">
              <b-input-group prepend="Opções de Filtro">
                <b-form-select v-model="selectedOption" :options="options" />
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col xl="6" lg="6" md="12" sm="12">
              <b-form-group>
                <b-input-group size="md" prepend="Filtro">
                  <b-form-input
                    type="search"
                    id="filterInput"
                    placeholder="Digite para pesquisar"
                    v-model="product"
                    @keyup.enter="getProducts(page)"
                  ></b-form-input>
                  <b-input-group-append> </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>

            <pagination :source="pagination" @navigate="navigate"></pagination>
          </b-row>

          <b-table
            id="tableItens"
            hover
            striped
            bordered
            responsive="sm"
            :items="items"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            @row-clicked="editProduct"
            head-variant="light"
          >
            <template v-slot:cell(imageUrl)="data">
              <img
                v-if="data.item.imageUrl"
                :src="data.item.imageUrl"
                alt="Thumbnail"
                style="height: 50px"
              />
              <span v-else>Sem imagem</span>
            </template>
          </b-table>
          <b-button
            disabled
            class="my-2 my-sm-0 mr-sm-2 w100"
            type="submit"
            @click="redirect('Cadastro')"
          >
            <i class="fa fa-plus fa-xl"></i>
            Cadastrar
          </b-button>
        </b-card>
      </transition>
    </b-col>
  </div>
</template>
<script>
import Loading from "vue-loading-overlay";
import Pagination from "../components/Pagination";
import axios from "axios";
import * as config from "@/config.json";
import AddProduct from "./AddProduct.vue";
import VueRouter from "vue-router";

export default {
  name: "Products",
  components: { Loading, Pagination },
  props: ["source"],
  data: () => {
    return {
      pagination: {},
      product: null,
      items: [],
      fields: [
        { key: "imageUrl", label: "Foto" },
        { key: "sku", label: "Barras" },
        { key: "description", label: "Descrição" },
        { key: "stockQuantity", label: "Estoque" },
        { key: "salePrice", label: "Valor" },
      ],
      options: [
        {
          value: null,
          text: "Descrição",
        },
        {
          value: 1,
          text: "Barras",
        },
      ],
      currentPage: 1,
      perPage: 7,
      isLoading: false,
      selectedOption: null,
    };
  },
  methods: {
    redirect(ref) {
      if (ref == "Cadastro") {
        this.$router.push(`/addProduct`);
      }
    },

    editProduct(p) {
      this.$router.push({
        name: "Cadastro de Produtos",
        params: {
          sku: p.sku,
          description: p.description,
          salePrice: p.salePrice,
          stockQuantity: p.stockQuantity,
        },
      });
    },

    cleanSearch() {
      this.product = "";
      this.getProducts(page);
    },

    navigate(page) {
      this.getProducts(page);
    },

    buildParams(option, pagina) {
      let params = new Object();

      if (option == null) {
        params.description = this.product;
      }

      if (option == 1) {
        params.sku = this.product;
      }

      params.pageSize = this.perPage;
      params.page = pagina;

      return params;
    },

    async getProducts(pagina) {
      const url = `${config.default.urlBase}/oac/site/${config.default.siteId}/products/search`;
      const params = this.buildParams(this.selectedOption, pagina);

      try {
        const response = await axios({
          url: url,
          method: "get",
          params: params,
          headers: { authorization: `${config.default.authorization}` },
        });

        const pagination = {
          records: response.data.records,
          page: response.data.page,
          pages: response.data.pages,
          rowsPerPage: this.perPage,
        };

        console.log({ response: response });
        this.items = response.data.items;
        this.pagination = pagination;
      } catch (error) {
        console.error({
          errorMessage: `[GetProducts] ${error}`,
        });
      }
    },
  },

  async beforeMount() {
    this.isLoading = true;
    await this.getProducts(1);
    this.isLoading = false;
  },
};
</script>
<style>
</style>